import TagManager from '@sooro-io/react-gtm-module'
import { getUserInfo } from './utils/general'

export const register = ({ user: { isLoggedIn = true, customer }, defaultShippingCountry } = {}) => {
	TagManager.dataLayer({
		dataLayer: {
			event: 'userRegistration',
			userRegistration: {
				registration_type: 'website',
			},
			user_info: getUserInfo({ isLoggedIn, customer, defaultShippingCountry }),
		},
	})
}
